import React from 'react';

const NotFoundPage = () => {
    const styles = {
        container: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            padding: '20px'
        },
        card: {
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '24px',
            padding: '60px 40px',
            maxWidth: '500px',
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)',
            animation: 'fadeIn 0.6s ease-out'
        },
        errorCode: {
            fontSize: '120px',
            fontWeight: '800',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            margin: '0',
            lineHeight: '1',
            animation: 'bounce 2s infinite'
        },
        title: {
            fontSize: '28px',
            fontWeight: '600',
            color: '#2d3748',
            margin: '24px 0 16px 0'
        },
        description: {
            fontSize: '16px',
            color: '#718096',
            lineHeight: '1.6',
            margin: '0 0 32px 0'
        },
        button: {
            display: 'inline-block',
            padding: '14px 32px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
        },
        buttonHover: {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(102, 126, 234, 0.6)'
        },
        illustration: {
            width: '200px',
            height: '200px',
            margin: '0 auto 24px',
            position: 'relative'
        },
        circle: {
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #667eea20 0%, #764ba220 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'pulse 3s infinite'
        }
    };

    const [isHovered, setIsHovered] = React.useState(false);

    const handleGoHome = () => {
        window.location.href = '/';
    };

    return (
        <>
            <style>
                {`
                    @keyframes fadeIn {
                        from {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    @keyframes bounce {
                        0%, 100% {
                            transform: translateY(0);
                        }
                        50% {
                            transform: translateY(-10px);
                        }
                    }
                    
                    @keyframes pulse {
                        0%, 100% {
                            transform: scale(1);
                            opacity: 0.8;
                        }
                        50% {
                            transform: scale(1.05);
                            opacity: 1;
                        }
                    }
                `}
            </style>
            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.illustration}>
                        <div style={styles.circle}>
                            <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
                                <circle cx="50" cy="50" r="40" stroke="#667eea" strokeWidth="3" strokeLinecap="round" strokeDasharray="4 6"/>
                                <path d="M30 45 L35 40 M35 45 L30 40" stroke="#667eea" strokeWidth="3" strokeLinecap="round"/>
                                <path d="M65 45 L70 40 M70 45 L65 40" stroke="#667eea" strokeWidth="3" strokeLinecap="round"/>
                                <path d="M35 65 Q50 55 65 65" stroke="#667eea" strokeWidth="3" strokeLinecap="round" fill="none"/>
                            </svg>
                        </div>
                    </div>
                    <h1 style={styles.errorCode}>404</h1>
                    <h2 style={styles.title}>Page introuvable</h2>
                    <p style={styles.description}>
                        Oups ! La page que vous recherchez semble avoir disparu dans le cyberespace.
                    </p>
                    <button
                        style={{
                            ...styles.button,
                            ...(isHovered ? styles.buttonHover : {})
                        }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        onClick={handleGoHome}
                    >
                        Retour à l'accueil
                    </button>
                </div>
            </div>
        </>
    );
};

export default NotFoundPage;